import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {getCookieGroups} from 'selectors/oneTrust';

/**
 * Custom hook to check if a cookie group is active.
 * @param {string} groupName - The name of the cookie group to check.
 * @returns {Object} - An object containing the status of the cookie group.
 * @returns {boolean} isCookieAvailable - Indicates if the cookie group is available.
 */
export const useCookieActiveGroup = (groupName: string) => {
    const cookieGroups = useHostSelector(getCookieGroups);
    const isCookieAvailable = cookieGroups?.includes(groupName);

    return {
        isCookieAvailable,
    };
};
